export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-crown-617f320c7746ed19ceca67224eadb9a9.svg";